import { isObjectEmpty, objectHasFields } from 'src/utils/aem-utils/utils';
import { ValidationOutcomes, ValidationResult } from '.';
import isButtonPropValid from './button-property-validator';
import isImagePropValid from './image-property-validator';
import { convertToAbsoluteLinkUrl } from 'src/utils';

const isCampaignMessagePropValid = (props: any): ValidationResult => {
  const vr: ValidationResult = {
    result: ValidationOutcomes.UNKNOWN,
    messages: [],
    componentProps: null,
  };

  if (isObjectEmpty(props)) {
    vr.messages.push('Campaign Message props are empty. {}');
    vr.result = ValidationOutcomes.FAILURE;
    return vr;
  }

  const preTextLength = props.preText ? props.preText.length : 0;
  const postTextLength = props.postText ? props.postText.length : 0;

  if (!props.hasOwnProperty('url')) {
    vr.messages.push(
      'Campaign Message is missing required field: url'
    );
    vr.result = ValidationOutcomes.FAILURE;
    return vr;
  }

  if (preTextLength + postTextLength === 0) {
    vr.messages.push(
      'Campaign Message is missing required fields: preText, postText'
    );
    vr.result = ValidationOutcomes.FAILURE;
    return vr;
  }

  if (props.hasOwnProperty('url')) {
    if (props.url.startsWith('www.')) props.url = 'https://' + props.url;
    props.url = convertToAbsoluteLinkUrl(props.url);
  }

  vr.result = ValidationOutcomes.SUCCESS;
  vr.componentProps = props;
  return vr;
};

const ValidateSlideShowBannerComponentProps = (
  props: any
): ValidationResult => {
  let vr: ValidationResult = {
    result: ValidationOutcomes.UNKNOWN,
    messages: [],
  };

  if (!objectHasFields(props, ['slides'])) {
    vr.messages.push('Slideshow Banner is missing required fields: slides');
    vr.result = ValidationOutcomes.FAILURE;
    return vr;
  }

  for (const slide of props.slides) {
    if (!objectHasFields(slide, ['desktopImage', 'mobileImage'])) {
      vr.messages.push(
        'Slideshow Banner is missing required fields: desktopImage, mobileImage'
      );
      vr.result = ValidationOutcomes.FAILURE;
      return vr;
    }
    if (!objectHasFields(slide, ['title'])) {
      vr.messages.push('Slideshow Banner is missing required fields: title');
      vr.result = ValidationOutcomes.FAILURE;
      return vr;
    }

    // check for valid image
    const imageValidationResult =
      isImagePropValid(slide.desktopImage) &&
      isImagePropValid(slide.mobileImage);
    if (imageValidationResult.result === ValidationOutcomes.FAILURE) {
      vr.messages = vr.messages.concat(imageValidationResult.messages);
      vr.result = ValidationOutcomes.FAILURE;
      return vr;
    } else if (imageValidationResult.result === ValidationOutcomes.WARNING) {
      vr.result = ValidationOutcomes.WARNING;
      vr.messages = vr.messages.concat(imageValidationResult.messages);
      props.image = imageValidationResult.componentProps;
    }

    // if it has button check for a valid buttons data - it's an array
    if (slide.hasOwnProperty('buttons') && slide.buttons.length > 0) {
      slide.buttons.forEach((button: any, index: number, o: any) => {
        const buttonValidationResult = isButtonPropValid(button);

        if (buttonValidationResult.result === ValidationOutcomes.FAILURE) {
          vr.result = ValidationOutcomes.WARNING;
          vr.messages = vr.messages.concat(buttonValidationResult.messages);
          vr.messages.push('Invalid button data, button deleted');
          slide.buttons.splice(index, 1);
        }
      });
    }

    // check for valid campaign message
    if (slide.hasOwnProperty('campaignMessage')) {
      // Fix Campaign Message to top
      slide.campaignMessagePosition = 'top';

      // check for valid campaign message
      const campaignMessageValidationResult = isCampaignMessagePropValid(
        slide.campaignMessage
      );
      if (
        campaignMessageValidationResult.result === ValidationOutcomes.FAILURE
      ) {
        vr.result = ValidationOutcomes.WARNING;
        vr.messages = vr.messages.concat(
          campaignMessageValidationResult.messages
        );
        vr.messages.push(
          'Invalid campaign message data, campaign message deleted'
        );
        delete slide.campaignMessage;
      }
    }
  }

  if (vr.result === ValidationOutcomes.UNKNOWN) {
    vr.result = ValidationOutcomes.SUCCESS;
    vr.messages.push('Slideshow Banner is valid');
  }

  vr.componentProps = props;
  return vr;
};

export default ValidateSlideShowBannerComponentProps;
